/* prettier-ignore */

import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToolsService } from 'src/app/services/tools.service';
import { NewCustomRouteService } from 'src/app/pages/new-custom-route/new-custom-route.service';
import { ModalController } from '@ionic/angular';
import { RegisterSubInterestTypeComponent } from './sub-interest-type/sub-interest-type.component';
import { DebugService } from 'src/app/services/debug.service';

@Component({
  selector: 'cicerone-register-step-interest-type',
  templateUrl: './step-interest-type.component.html',
  styleUrls: ['./step-interest-type.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class RegisterInterestTypeComponent {    
    @Output() private interestTypeEmitter: EventEmitter<any> = new EventEmitter<any>();
    @Input() categories?:any[] = [];
    @Input() subCategories?:any[] = [];
    @Input() isRegisterStandaloneApp: boolean = false;
    public items: any = [];
    public modal: any;
    
    constructor(
        public translate: TranslateService, 
        public tools: ToolsService,
        public modalCtrl: ModalController, 
        private debugService: DebugService,
        private routeService: NewCustomRouteService) 
    {}

    ngOnInit(){
        if (this.tools.isDistributor) this.generateDistributorData();
        if (this.tools.isApp) this.generateAppData();
        if (this.isRegisterStandaloneApp) this.generateAppData();
    }


//--------- APPS ------------------------------------------------------------------------------------------------------------------------------------------------------
    generateAppData(){
        const categoriesData  = structuredClone(this.categories?.filter(e => (!e.sections_app || e.sections_app.length == 0 || e.sections_app.includes('Register'))));
        this.debugService.info(categoriesData, '[StepInterestTypeComponent] categoriesData');
        const subcategoriesData = structuredClone(this.subCategories);
        this.items = categoriesData.map(category => {
            const subcategories = subcategoriesData
              .filter(subcategory => subcategory.category_id === category.id)
              .map(subcategory => ({
                id: subcategory.id,
                name: subcategory.name,
                image: subcategory.image,
                imageFallback: subcategory.imageFallback,
                selected: false,
              }));
            return {
              id: category.id,
              name: category.name,
              image: category.image,
              imageFallback: category.imageFallback,
              subcategories,
              selected: false,
            };
        });
    }

    async setAppSelectedOption(item){
        if (item.subcategories?.length > 0){
            this.modal = await this.modalCtrl.create({
                component: RegisterSubInterestTypeComponent,
                cssClass: "subCategoriesModal",
                componentProps: { category: item, isRegisterStandaloneApp: this.isRegisterStandaloneApp },
            });
            await this.modal.present();
            const { data } = await this.modal.onDidDismiss();
            this.setAppData()
            return;
        }
        item.selected = !item.selected;
        this.setAppData()
    }

    setAppData(){
        const data = this.items.filter(category => category.selected || category.subcategories.filter(sub => sub.selected)?.length > 0).map(category => {
            const subcategories = category.subcategories.filter(sub => sub.selected).map(sub => sub.id).flat();
            return { id: category.id, subcategories }
        })
        this.routeService.routeConfig = {...this.routeService.routeConfig, categories: data};
        this.emitData(data);
    }

    emitData(data){
        const populatedData = data?.map(e => ({id: e.id, subCategories: e.subcategories}));
        this.interestTypeEmitter.emit(populatedData)
    }

//--------- DISTRIBUTORS ------------------------------------------------------------------------------------------------------------------------------------------------------
    generateDistributorData(){
        const categoriesData  = structuredClone(this.categories?.filter(e => (!e.sections_app || e.sections_app.length == 0 || e.sections_app.includes('Register'))));
        const subcategoriesData = structuredClone(this.subCategories);
        this.items = categoriesData.map(category => {
            const subcategories = subcategoriesData
              .filter(subcategory => category.categories.includes(subcategory.category_id))
              .map(subcategory => ({
                ids: subcategory.subCategories,
                name: subcategory.name,
                image: subcategory.image,
                imageFallback: subcategory.imageFallback,
                selected: false,
              }));
            return {
              ids: category.categories,
              name: category.name,
              image: category.image,
              imageFallback: category.imageFallback,
              subcategories,
              selected: false,
            };
        });
    }

    async setDistributorSelectedOption(item){
        if (item.subcategories?.length > 0){
            this.modal = await this.modalCtrl.create({
                component: RegisterSubInterestTypeComponent,
                cssClass: "subCategoriesModal",
                componentProps: { category: item, isRegisterStandaloneApp: this.isRegisterStandaloneApp },
            });
            await this.modal.present();
            const { data } = await this.modal.onDidDismiss();
            this.setDistributorData()
            return;
        }
        item.selected = !item.selected;
        this.setDistributorData()
    }

    setDistributorData(){
        const data = this.items.filter(category => category.selected || category.subcategories.filter(sub => sub.selected)?.length > 0).map(category => {
            const subcategories = category.subcategories.filter(sub => sub.selected).map(sub => sub.ids).flat();
            return { ids: category.ids, subcategories }
        })
        this.routeService.routeConfig = {...this.routeService.routeConfig, categories: data}
    }

    checkSubcategoriesActive(subcategories){
        return subcategories.filter(subcategory => subcategory.selected)?.length || 0;
    }

    focusin(evt) {
        evt.stopPropagation();
    }
    
}